import React from "react"
import { AiFillCaretDown, AiFillCaretUp, AiFillDelete  } from "react-icons/ai"
import styled from "styled-components"

const ExpandableCard = ({ toggle, handleUp, handleDown, handleDelete, question ,role }) => {


  return (
    <CardWrap>
      <div className="title_cont">
        <div className="title">{question?.question}</div>
        {!toggle ? (
          <AiFillCaretDown className="toggleIcon" onClick={handleDown} size={25} color="#000" />
        ) : (
          <AiFillCaretUp className="toggleIcon" onClick={handleUp} size={25} color="#000" />
        )}
      {
        role === 'admin' &&
        <span onClick={() => handleDelete(question.id)} className="deletebtn">
        <AiFillDelete size={25} color="red" />
        </span>
      }
      </div>
      <div className={toggle ? "expanded" : "not_expanded"}>
        <p>{question?.answer}</p>
      </div>
    </CardWrap>
  )
}

export default ExpandableCard

const CardWrap = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  width: 95%;
  height: fit-content;
  box-sizing: border-box;
  padding: 0.5rem;
  user-select: none;
  background: ${({ theme }) => theme.background};
  border-radius: 5px;
  margin: 10px 0;
  .title_cont {
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;

    .title {
      font-size: 1rem;
      font-family: Montserrat;
      font-style: normal;
      font-weight: normal;
      color: ${({ theme }) => theme.text};
    }
  }

  .toggleIcon {
      cursor: pointer;
  }
  .expanded {
      width: inherit;
      height: fit-content;

  }

  .not_expanded{
    display: none;
  }

  .deletebtn {
    background: none;
    position: absolute;
    right: -2rem;
    cursor: pointer;
  }
`
